// extracted by mini-css-extract-plugin
export default {"detailsWrap":"MovieDetails_detailsWrap__TVLY-","col":"MovieDetails_col__wEkNk","firstP":"MovieDetails_firstP__sehH8"};